import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';


// Componentes
import CalendarHeader from '../../components/calendar/CalendarHeader';
import FilterBar from '../../components/calendar/FilterBar';
import MonthView from '../../components/calendar/MonthView';
import WeekView from '../../components/calendar/WeekView';
import DayView from '../../components/calendar/DayView';
import DayDetailModal from '../../components/calendar/DayDetailModal';
import TicketFormModal from '../../components/calendar/TicketFormModal';
import { getCalendarList, getCalendarPaginateDay, searchById, getCalendarData } from '../../services/called.service'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import CustomizedSnackbars from '../../components/material-snackbars'



// Utilitários e dados
import { mockTickets } from '../../data/mock-data';
import {
  getStatusColor,
  getStatusIcon,
  getPriorityColor,
  formatDate,
  formatDateForSubmission,
  isToday,
  getDaysInMonth,
  getFirstDayOfMonth,
  monthNames,
  weekdayNames
} from '../../utils/ticketUtils';

// Estilos
import './ticket-calendar.css';
import { PapiroConsole } from 'src/utils/papiroConsole';
import Api from 'src/services/api';

import { Overlay } from "../../styles/global";


const TicketCalendar = (props) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  let history = useHistory()

  // Estados principais
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [quantityOfTicketsByDay, setQuantityOfTicketsByDay] = useState([]);
  const [modalPagination, setModalPagination] = useState({ page: 1, perPage: 10 });
  const [modalSearch, setModalSearch] = useState('');
  const [statusesOptions, setStatusesOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [notificationMessage, setNotificationMessage] = useState('')
  const [notificationVariant, setNotificationVariant] = useState('error')
  const [openNotification, setOpenNotification] = useState(false)
  const [renderedList, setRenderedList] = useState(false)

  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());



  // Estados para novas funcionalidades
  const [view, setView] = useState('month'); // 'month', 'week', 'day'
  const [isTicketFormOpen, setIsTicketFormOpen] = useState(false);
  const [ticketToEdit, setTicketToEdit] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    status: 'all',
    priority: 'all',
    search: ''
  });

  // Extrair mês e ano atual
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();






  // Carregar tickets
  useEffect(() => {
    try {
      setLoading(true);
      Promise.all([calendarCalledList(currentMonth, currentYear, 'month'), calendarData()])
        .then(() => {
          setLoading(false);
        })
        .catch(error => {
          console.error("Erro ao carregar os dados:", error);
          setLoading(false); // Você pode querer lidar com o erro de forma diferente
        });
    } catch (err) {
      console.error("Erro ao carregar tickets:", err);
      setLoading(false);
    }
  }, []);

  // Aplicar filtros quando mudam
  useEffect(() => {
    applyFilters();
  }, [filterOptions, tickets]);

  useEffect(() => {
    if (isModalOpen && selectedTicket == null) {
      setLoading(true);
    }
  }, [isModalOpen]);


  const setMessage = (open, variant, message) => {

    setOpenNotification(open)
    setNotificationVariant(variant)
    setNotificationMessage(message)
  }

  const closeNotification = _ => {
    setOpenNotification(false)
  }

  async function consultCalled(calledId) {


    let language = window.location.pathname.split('/')[1]
    if (language != "pt" && language != "es" && language != "en")
      language = "pt"

    setLoading(true);
    let response = await searchById(calledId);
    if (
      response != null &&
      response.success != null &&
      response.success &&
      response.data != null &&
      response.data
    ) {
      setLoading(false);
      history.push(`/${language}/called-view/${calledId}`)

    } else {
      Api.kickoff(response);
      setLoading(false);
    }
  }

  function createCalled(day = null, month = null) {

    // currentMonth + 1, currentYear, day, 1

    var isClient = true;
    const { userSession } = props;
    
    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        isClient = false;
      }
    }
    );

    let language = window.location.pathname.split('/')[1]
    if (language != "pt" && language != "es" && language != "en")
      language = "pt"

    if (day != null) {


      var date = moment(`${currentYear}-${currentMonth + 1}-${day}`, 'YYYY-MM-DD');

      if (month != null) {
        date = moment(`${currentYear}-${month + 1}-${day}`, 'YYYY-MM-DD');
      }
      const actualDate = moment();


      var isafter = moment(actualDate).isAfter(date);

      PapiroConsole.log("date comparasion")
      PapiroConsole.log(date)
      PapiroConsole.log(actualDate)
      PapiroConsole.log(isafter)

      




      if (isafter) {

        if (isClient) {
          history.push(`/${language}/called-registration-client`)
        }
        else {
          history.push(`/${language}/called-registration`)
        }

        // Coloque a sua ação aqui
      } else {
        if (isClient) {
          history.push(`/${language}/called-registration-client`)
        }
        else {
          history.push(`/${language}/called-registration`, { dueDate: date.format('YYYY-MM-DD') });
        }

      }


      PapiroConsole.log("date aqui 123")
      PapiroConsole.log(date)


    }
    else {



      if (isClient) {
        history.push(`/${language}/called-registration-client`)
      }
      else {
        history.push(`/${language}/called-registration`)
      }




    }







  }

  async function trackCalled(calledId) {


    let language = window.location.pathname.split('/')[1]
    if (language != "pt" && language != "es" && language != "en")
      language = "pt"

    setLoading(true);
    let response = await searchById(calledId);
    if (
      response != null &&
      response.success != null &&
      response.success &&
      response.data != null &&
      response.data
    ) {
      setLoading(false);
      history.push(`/${language}/called-accompaniment/${calledId}`)

    } else {
      Api.kickoff(response);
      setLoading(false);
    }
  }

  // Função para aplicar filtros
  const applyFilters = () => {
    if (!tickets.length) return; // Proteção contra erro quando tickets estiver vazio

    let filtered = [...tickets];

    // Filtrar por status
    if (filterOptions.status !== 'all') {
      filtered = filtered.filter(ticket => ticket.status?.name === filterOptions.status);
    }

    // Filtrar por prioridade
    if (filterOptions.priority !== 'all') {
      filtered = filtered.filter(ticket => ticket.priority?.name === filterOptions.priority);
    }

    // Filtrar por pesquisa
    if (filterOptions.search) {
      const searchLower = filterOptions.search.toLowerCase();
      filtered = filtered.filter(ticket => {
        // Verificar se as propriedades existem antes de chamar toLowerCase()
        return (
          (ticket.title && ticket.title.toLowerCase().includes(searchLower)) ||
          (ticket.description && ticket.description.toLowerCase().includes(searchLower)) ||
          (ticket.requester && ticket.requester.toLowerCase().includes(searchLower)) ||
          (ticket.id && ticket.id.toString().includes(searchLower))
        );
      });
    }

    setFilteredTickets(filtered);
  };

  // Handler para mudança de filtros
  const handleFilterChange = (type, value) => {
    setFilterOptions(prev => ({
      ...prev,
      [type]: value
    }));
  };

  // Navegar para o mês anterior
  const prevMonth = async () => {
    PapiroConsole.log("currentYear")
    PapiroConsole.log(currentYear)
    PapiroConsole.log(currentMonth - 1)

    setCurrentDate(new Date(currentYear, currentMonth - 1, 1));

    var date = new Date(currentYear, currentMonth - 1, 1)
    var year = date.getFullYear();
    PapiroConsole.log("year")
    PapiroConsole.log(year)
    setSelectedYear(year)

    setLoading(true);
    await calendarCalledList(currentMonth - 1, year)
    setLoading(false);
  };

  // Navegar para o próximo mês
  const nextMonth = async () => {
    PapiroConsole.log("currentYear")
    PapiroConsole.log(currentYear)
    PapiroConsole.log(currentMonth - 1)
    var date = new Date(currentYear, currentMonth - 1, 1)
    var year = date.getFullYear();
    PapiroConsole.log("year")
    PapiroConsole.log(year)
    setSelectedYear(year)
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
    setLoading(true);
    await calendarCalledList(currentMonth + 1, year)
    setLoading(false);
  };

  const selectMonthCalendar = async (monthIndex) => {
    PapiroConsole.log("monthIndex")
    PapiroConsole.log(monthIndex)
    PapiroConsole.log("selectedYear")
    PapiroConsole.log(selectedYear)
    setCurrentDate(new Date(selectedYear, monthIndex, 1));
    setLoading(true);
    await calendarCalledList(monthIndex, selectedYear)
    setLoading(false);
  };




  // Ir para hoje
  const goToToday = async () => {

    const currentDate = new Date();
    // Dia do mês (1–31)
    const month = currentDate.getMonth() + 1;    // Mês (0–11) → +1 para ficar 1–12
    const year = currentDate.getFullYear()
    setCurrentDate(currentDate);

    setLoading(true);
    await calendarCalledList(month - 1, year)
    setLoading(false);
  };

  // Verificar se é o dia atual (wrapper da função utilitária)
  const isTodayWrapper = (day) => {
    return isToday(day, currentMonth, currentYear);
  };

  // Formatar data (wrapper da função utilitária)
  const formatDateWrapper = (day) => {
    return formatDate(day, currentMonth, currentYear);
  };

  // Obter tickets para um dia específico
  const getTicketsForDate = (day) => {

    if (filteredTickets.length === 0) return [];



    const dateStr = formatDateWrapper(day);


    return filteredTickets.filter(ticket => {

      var date = moment(ticket.duedate).format("DD/MM/YYYY");
      // const dueDate = ticket.duedate.split(' ')[0];
      const dueDate = date.split(' ')[0];
      var x = dueDate == dateStr;
      return dueDate == dateStr;
    });
  };


  const getLenghtForDate = (day) => {

    PapiroConsole.log("day getLenghtForDate")
    PapiroConsole.log(day)

    var quantityofcalleds = 0;

    if (quantityOfTicketsByDay.length === 0) return [];

    quantityOfTicketsByDay.forEach(c => {
      if (day == c.day) {

        PapiroConsole.log("quantityOfTicketsByDay day")
        PapiroConsole.log(day)
        PapiroConsole.log(c)
        PapiroConsole.log(c.quantityofcalleds)
        quantityofcalleds = c.quantityofcalleds;
      }
    });

    return quantityofcalleds;

  };

  // Filtrar tickets por pesquisa no modal
  const getFilteredModalTickets = (dayTickets) => {
    if (!modalSearch.trim()) {
      return dayTickets; // Retorna todos os tickets se não houver pesquisa
    }

    const searchLower = modalSearch.toLowerCase();
    return dayTickets.filter(ticket => {
      // Verificar se as propriedades existem antes de chamar toLowerCase()
      return (
        (ticket.title && ticket.title.toLowerCase().includes(searchLower)) ||
        (ticket.description && ticket.description.toLowerCase().includes(searchLower)) ||
        (ticket.requester && ticket.requester.toLowerCase().includes(searchLower)) ||
        (ticket.id && ticket.id.toString().includes(searchLower))
      );
    });
  };

  // Obter tickets paginados para o modal
  const getPaginatedTickets = (dayTickets) => {

    if (!dayTickets) return [];


    // Primeiro aplicar filtro de pesquisa
    const filteredModalTickets = getFilteredModalTickets(dayTickets);

    const startIndex = 0;
    const endIndex = modalPagination.page * modalPagination.perPage;

    PapiroConsole.log("dayTickets here")
    PapiroConsole.log(dayTickets)
    PapiroConsole.log(startIndex)
    PapiroConsole.log(endIndex)

    return {
      visibleTickets: filteredModalTickets.slice(startIndex, endIndex),
      hasMore: selectedDay.ticketsLength > endIndex,
      totalCount: filteredModalTickets.length,
      filteredCount: filteredModalTickets.length,
      totalOriginalCount: dayTickets.length
    };
  };

  // Carregar mais tickets no modal
  const handleLoadMore = () => {



    calendarPaginateDay(selectedDay.day, modalPagination.page + 1);
    setModalPagination(prev => ({
      ...prev,
      page: prev.page + 1
    }));
  };

  // Lidar com pesquisa no modal
  const handleModalSearch = (searchTerm) => {
    setModalSearch(searchTerm);
    setModalPagination({ page: 1, perPage: 10 }); // Reset da paginação quando pesquisar
  };

  // Abre o modal com os tickets do dia


  // Fechar o modal
  const closeModal = () => {

    setRenderedList(false);
    setIsModalOpen(false);
    setSelectedDay(null);
    setSelectedTicket(null);
    setModalSearch('');
  };

  // Mostrar detalhes do ticket
  const showTicketDetails = (ticket) => {
    if (!isModalOpen) {
      setIsModalOpen(true);
    }
    setSelectedTicket(ticket);
  };

  // Voltar para a lista de tickets do dia
  const backToTicketList = () => {
    setSelectedTicket(null);
    if (selectedDay == null) {

      closeModal();
    }
  };

  // Funções para o form de criar/editar ticket
  const openTicketForm = (ticket = null, day = null) => {
    if (ticket) {
      setTicketToEdit(ticket);
    } else if (day) {
      setTicketToEdit({
        id: '',
        title: '',
        description: '',
        requester: '',
        assignedTo: '',
        status: 'Novo',
        priority: 'Média',
        predictedDate: `${formatDateWrapper(day)} 12:00`
      });
    } else {
      setTicketToEdit(null);
    }
    setIsTicketFormOpen(true);
  };

  const closeTicketForm = () => {
    setIsTicketFormOpen(false);
    setTicketToEdit(null);
  };

  const handleSaveTicket = (ticketData) => {
    if (ticketData.id) {
      // Atualizar ticket existente
      const updatedTickets = tickets.map(t =>
        t.id === ticketData.id ? { ...t, ...ticketData } : t
      );
      setTickets(updatedTickets);
    } else {
      // Criar novo ticket
      const newTicket = {
        ...ticketData,
        id: Math.max(...tickets.map(t => t.id), 0) + 1
      };
      setTickets([...tickets, newTicket]);
    }

    closeTicketForm();
  };

  // Excluir ticket
  const handleDeleteTicket = (ticketId) => {
    const updatedTickets = tickets.filter(t => t.id !== ticketId);
    setTickets(updatedTickets);
    closeModal();
  };

  const calendarCalledList = async (month = 0, year = 0, view = 'month') => {
    const intl = props.intl

    let result = await getCalendarList(month, year, view)
    if (result && result.success) {

      PapiroConsole.log("result calendarList")
      PapiroConsole.log(result)
      if (result.data) {

        PapiroConsole.log("result calendarList 2")
        PapiroConsole.log(result.data.calleds)
        setTickets(result.data.calleds);
        setFilteredTickets(result.data.calleds);
        setQuantityOfTicketsByDay(result.data.quantityofcalleds);

      }

    } else {
      
      setLoading(false)
      setOpenNotification(true)
      setNotificationVariant("error")
      setNotificationMessage(result && result.response && result.response.data && result.response.data.errors ? result && result.response.data && result.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))

      Api.kickoff(result);
    }

    // setLoading(false);
  }

  const calendarData = async () => {

    const intl = props.intl
    let result = await getCalendarData()
    if (result && result.success) {

      PapiroConsole.log("result calendarList")
      PapiroConsole.log(result)
      if (result.data) {

        setStatusesOptions(result.data.status ? result.data.status : []);

        let values = result.data.priority ? [...result.data.priority, { id: 0, name: 'Todas' }] : [];
        setPriorityOptions(values);

      }

    } else {
      setLoading(false)
      setOpenNotification(true)
      setNotificationVariant("error")
      setNotificationMessage(result && result.response && result.response.data && result.response.data.errors ? result && result.response.data && result.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
      Api.kickoff(result);
    }


  }

  // const calendarPaginateDay = async (month = 0 ,year = 0, day ) => {

  // }


  const calendarPaginateDay = async (day, page) => {
    const intl = props.intl
    setLoading(true);
    let result = await getCalendarPaginateDay(currentMonth + 1, currentYear, day, page)
    if (result && result.success) {

      PapiroConsole.log("result calendarList")
      PapiroConsole.log(result)
      if (result.data) {

        PapiroConsole.log("day NEW")
        PapiroConsole.log(day)
        const dayTickets = result.data;
        PapiroConsole.log("day 3 ")
        PapiroConsole.log(day)
        setSelectedDay({ day, month: currentMonth + 1, year: currentYear, tickets: [...selectedDay.tickets, ...dayTickets], ticketsLength: result.count });
        setLoading(false);

      }

    } else {
      setLoading(false)
      setOpenNotification(true)
      setNotificationVariant("error")
      setNotificationMessage(result && result.response && result.response.data && result.response.data.errors ? result && result.response.data && result.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
      Api.kickoff(result);


    }

    setLoading(false);


  }

  const openDayDetails = async (day) => {
    setIsModalOpen(true);




    let result = await getCalendarPaginateDay(currentMonth + 1, currentYear, day, 1)
    if (result && result.success) {

      PapiroConsole.log("result calendarList")
      PapiroConsole.log(result)
      if (result.data) {
        const dayTickets = result.data;
        setRenderedList(true);
        PapiroConsole.log("result calendarList 2")
        setLoading(false);
        setSelectedDay({ day, month: currentMonth + 1, year: currentYear, tickets: dayTickets, ticketsLength: result.count });
        setModalPagination({ page: 1, perPage: 10 }); // Reset pagination
        setModalSearch(''); // Reset da pesquisa

      }

    } else {
      setLoading(false);
      Api.kickoff(result);
    }

    // setLoading(false);



  };

  // Escolher a visualização baseada no estado
  const renderViewContent = () => {

    PapiroConsole.log("renderViewContent")
    const viewProps = {
      currentDate,
      currentMonth,
      currentYear,
      weekdayNames,
      monthNames,
      getTicketsForDate,
      getLenghtForDate,
      getStatusColor,
      getStatusIcon,
      getPriorityColor,
      formatDate: formatDateWrapper
    };

    switch (view) {
      case 'week':
        return (
          <WeekView
            {...viewProps}
            filteredTickets={filteredTickets}
            openTicketForm={openTicketForm}
            showTicketDetails={showTicketDetails}
            createCalled={createCalled}
            statusesOptions={statusesOptions}
              openDayDetails={openDayDetails}
          />
        );
      case 'day':
        return (
          <DayView
            {...viewProps}
            openTicketForm={openTicketForm}
            showTicketDetails={showTicketDetails}
            statusesOptions={statusesOptions}
              openDayDetails={openDayDetails}

          />
        );
      case 'month':
      default:
        return (
          <MonthView
            {...viewProps}
            getFirstDayOfMonth={getFirstDayOfMonth}
            getDaysInMonth={getDaysInMonth}
            isToday={isTodayWrapper}
            openDayDetails={openDayDetails}
            openTicketForm={openTicketForm}
            createCalled={createCalled}
          />
        );
    }
  };

  // Exibe um indicador de carregamento



  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Box sx={{ p: isTablet ? 2 : 3, maxWidth: 1400, mx: 'auto' }}>
        <CalendarHeader
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          monthNames={monthNames}
          view={view}
          setView={setView}
          prevMonth={prevMonth}
          nextMonth={nextMonth}
          goToToday={goToToday}
          selectMonthCalendar={selectMonthCalendar}
          setSelectedYear={setSelectedYear}
          selectedYear={selectedYear}
        />

        <FilterBar
          filterOptions={filterOptions}
          handleFilterChange={handleFilterChange}
          openTicketForm={openTicketForm}

          statusesOptions={statusesOptions}
          priorityOptions={priorityOptions}
          createCalled={createCalled}
        />

        {renderViewContent()}

        {/* Modal de detalhes do dia */}
        {isModalOpen && (
          <DayDetailModal
            open={isModalOpen}
            onClose={closeModal}
            selectedDay={selectedDay}
            selectedTicket={selectedTicket}
            onTicketClick={showTicketDetails}
            onBackToList={backToTicketList}
            paginationInfo={getPaginatedTickets(selectedDay ? selectedDay.tickets : null)}
            onLoadMore={handleLoadMore}
            getStatusColor={getStatusColor}
            getPriorityColor={getPriorityColor}
            onEditTicket={openTicketForm}
            onDeleteTicket={handleDeleteTicket}
            searchTerm={modalSearch}
            onSearchChange={handleModalSearch}
            consultCalled={consultCalled}
            trackCalled={trackCalled}
            setMessage={setMessage}
            setLoading={setLoading}
            createCalled={createCalled}
            renderedList={renderedList}

          />
        )}

        {/* Modal de criar/editar ticket */}
        <TicketFormModal
          open={isTicketFormOpen}
          onClose={closeTicketForm}
          onSave={handleSaveTicket}
          ticketData={ticketToEdit}

        />
      </Box>
      <CustomizedSnackbars
        variant={notificationVariant}
        message={notificationMessage}
        isOpen={openNotification}
        toClose={closeNotification} />


      {loading &&
        <Overlay>
          <CircularProgress color="secondary" />
        </Overlay>
      }



    </LocalizationProvider>
  );
};

export default TicketCalendar;